import { render, staticRenderFns } from "./StockControlJournal.vue?vue&type=template&id=17bc3488&scoped=true&"
import script from "./StockControlJournal.vue?vue&type=script&lang=js&"
export * from "./StockControlJournal.vue?vue&type=script&lang=js&"
import style0 from "./StockControlJournal.vue?vue&type=style&index=0&id=17bc3488&scoped=true&lang=css&"
import style1 from "./StockControlJournal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bc3488",
  null
  
)

export default component.exports
import {QSpace,QBtn,QTr,QTh,QTd,QTooltip,QInnerLoading,QSpinnerGears,QField,QCheckbox} from 'quasar'
component.options.components = Object.assign({QSpace,QBtn,QTr,QTh,QTd,QTooltip,QInnerLoading,QSpinnerGears,QField,QCheckbox}, component.options.components || {})
